import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import DemoPreview from "@/components/DemoPreview";
import Portfolio from "@/components/Portfolio";
import Process from "@/components/Process";
import Estimator from "@/components/Estimator";
import Pricing from "@/components/Pricing";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main id="top" className="relative">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <DemoPreview />
      <Portfolio />
      <Process />
      <Estimator />
      <Pricing />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
}